  <div class="detail-scroll">

<mat-tab-group
  animationDuration="150ms"
  (selectedTabChange)="onTabChange($event)"
>

  <!-- METADATA -->
  <mat-tab label="Info">
    <ng-template matTabContent>
      <div class="card">
        <div class="card-title">Record Info</div>

        <ng-container *ngIf="metaLoaded; else loading">
          <ng-container *ngIf="metaEntries.length; else noMeta">
            <div class="kv-grid meta-grid">
              <div class="kv" *ngFor="let item of metaEntries">
                <span class="label">{{ item.label }} :  <span class="value">{{ item.value || '-' }}</span> </span>
               
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </mat-tab>

  <!-- DEVIATION -->
  <mat-tab label="Deviation Details">
    <ng-template matTabContent>
      <div class="card">
        <div class="card-title">Deviation Details</div>

        <ng-container *ngIf="devLoaded; else loading">
          <ng-container *ngIf="devEntries.length; else noDev">
            <div class="kv-grid deviation-grid">
              <div class="kv" *ngFor="let item of devEntries">
                <span class="label">{{ item.label }} : <span class="value">{{ item.value || '-' }}</span> </span>
                
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </mat-tab>

 <!-- ROOT CAUSE -->
<mat-tab label="Root Cause">
  <ng-template matTabContent>
    <ng-container *ngIf="rootCauses.length; else noRootCause">
      <div class="root-cause-container">
        <div class="root-cause-card">
            <ag-grid-angular
           
            class="ag-theme-balham"
            style="width: 100%; height: 200px"
            [rowData]="rootCauses"
            [defaultColDef]="defaultColDef"
            [columnDefs]="rootcausecolumnDefs"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="2"
            [enableBrowserTooltips]="true"
            (gridReady)="onGridReady($event)"
            >
</ag-grid-angular>
          
        </div>
      </div>
    </ng-container>
  </ng-template>
</mat-tab>

<ng-template #noRootCause>
  <div class="empty-state">No root cause data available</div>
</ng-template>



  <!-- CAPA -->
<mat-tab label="CAPA">
  <ng-template matTabContent>
    <ng-container *ngIf="capas.length; else noCapa">
      <div class="capa-container">
        <div class="capa-card">
            <ag-grid-angular
            
            class="ag-theme-balham"
            style="width: 100%; height: 200px"
            [rowData]="capas"
            [defaultColDef]="defaultColDef"
            [columnDefs]="capacolumnDefs"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="2"
            [enableBrowserTooltips]="true"
            (gridReady)="onGridReady($event)"
           
            >
            </ag-grid-angular>
        </div>
      </div>
    </ng-container>
  </ng-template>
</mat-tab>

<ng-template #noCapa>
  <div class="empty-state">No CAPA data available</div>
</ng-template>

</mat-tab-group>
</div>

<!-- STATES -->
<ng-template #loading>
  <div class="empty-state">Loading...</div>
</ng-template>

<ng-template #noMeta>
  <div class="empty-state">No Record Info available</div>
</ng-template>

<ng-template #noDev>
  <div class="empty-state">No deviation details available</div>
</ng-template>